import merge from 'lodash/merge';
import { ForwardedRef, forwardRef } from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';

type LinkWithOriginProps = LinkProps & {
    disableReturnUrlStateSetting?: boolean;
};

const LinkWithOrigin = forwardRef((props: LinkWithOriginProps, ref: ForwardedRef<HTMLAnchorElement>) => {
    const { state, disableReturnUrlStateSetting, ...rest } = props;
    const { pathname, search, state: locationState } = useLocation();

    const maybeAdjustedState = disableReturnUrlStateSetting
        ? state
        : {
              ...merge({}, locationState, state),
              returnTo: state?.returnTo !== undefined ? state.returnTo : `${pathname + search}`,
          };

    return <Link ref={ref} {...rest} state={maybeAdjustedState} />;
});

export default LinkWithOrigin;
